import { Show, SimpleShowLayout, TextField } from "react-admin";
import StringArray from "../common/StringArray";

export const RuleDeemedSupplierShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="threshold" />
      <TextField source="taxIdentifier24s" />
      <TextField source="taxIdentifierName" />
      <StringArray fieldName="countriesFrom" label="Countries From" />
      <StringArray fieldName="countriesTo" label="Countries To" />
      <StringArray
        fieldName="exceptCountriesFrom"
        label="Exept Countries From"
      />
      <TextField source="currency" />
      <TextField source="sapAccount1" />
      <TextField source="sapAccount2" />
    </SimpleShowLayout>
  </Show>
);

export default RuleDeemedSupplierShow;
